<template>
    <div>
        <Bar
            :chart-options="chartOptions"
            :chart-data="chartData"
            :chart-id="chartId"
            :dataset-id-key="datasetIdKey"
            :plugins="plugins"
            :css-classes="cssClasses"
            :styles="styles"
            :width="width"
            :height="height"
            ref="bar"
        />
       
    </div>
</template>
<script>
import { Bar } from 'vue-chartjs/legacy'
import ChartDataLabels from 'chartjs-plugin-datalabels';

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from 'chart.js'

ChartJS.register(Title, Tooltip,  BarElement, CategoryScale, LinearScale, Legend)
ChartJS.register(ChartDataLabels);

export default {
    props: ['valueInput',  'chartDataInput', 'firstLabel', 'lastLabel'],
    components: { Bar },
    model: {
        prop: 'chartData',
        event: 'valueChange'
    },
   
    computed: {
       
        chartData: {
            get: function() {
                return this.chartDataInput
            },
            set: function(value) {
                
                this.$emit('valueChange', value)
            }
        },
    },
    data(){
        return{
            dateRange: ['2019-09-10', '2019-09-20'],
            chartOptions: {
                responsive: true,
                maintainAspectRatio: false,
                indexAxis: 'y',
                scales: {
                    x: {
                        stacked: true,
                        ticks: {
                            // maxRotation: 90,
                            // minRotation: 90,
                            font: {
                                size: 16,
                            },
                            callback: function(value,value2) {
                                if(value == 0)
                                    return this.firstLabel
                                if(value2 == 10)
                                return this.lastLabel
                            }.bind(this)
                        }
                    },
                    y: {
                        stacked: true,
                        ticks: {
                            callback:() => {
                                
                                return "";
                            }
                        }
                    }
                },
                plugins: {
                    // responsive: true,
                    // maintainAspectRatio: false,
                    // circumference: 180,
                    legend: {
                        display:true,
                        position: 'bottom'
                    },
                    tooltip:{
                        callbacks:{
                            title: (context) =>{
                                return context[0].label.substring(0,20)
                            }
                        }
                    },

                    datalabels: {
                        color: '#ffffff',
                        anchor: 'center',
                        align: 'center',
                        font: {
                        weight: 'bold',
                        size: 14
                        },
                        formatter: (value) => `${value}%`
                    }
                    
                    

                }
            },
            chartId: 'bar-chart',
            datasetIdKey: 'label',
            width: 350,
            height: 120,
            cssClasses: '',
            styles: {
                
                
            },
            plugins: [
                ChartDataLabels
            ],
            
          

          

        }
    },
    mounted(){
    },

    methods:{
        
    }


   
}
</script>

<style lang="scss">
    .bar-horizontal{
        &-container{
            display: flex;
            flex-direction: column;
        }
    }
</style>